import { Checkbox } from "PFComponents/checkbox";
import { Label } from "PFComponents/label";
import { Typography } from "PFComponents/typography";
import { CheckboxesFieldValue } from "PFTypes";

import { ComponentProps } from "../../component_prop_types";
import css from "./checkboxes_wrapper.module.scss";

type CheckboxesWrapperProps = Pick<
  ComponentProps,
  "property" | "label" | "error" | "required" | "disabled" | "tabIndex" | "style"
> & {
  value: CheckboxesFieldValue;
  onChange: (newValue: CheckboxesFieldValue) => void;
};

export const CheckboxesWrapper = ({
  property,
  label,
  onChange,
  error,
  value = [],
  required,
  disabled,
  tabIndex,
  style
}: CheckboxesWrapperProps) => {
  const handleChange = (id: string, checked: boolean) => {
    const newValue = [...value];
    const checkboxIndex = newValue.findIndex((checkbox) => checkbox.id === id);

    if (checkboxIndex < 0) {
      newValue.push({
        id,
        value: checked
      });
    } else {
      newValue[checkboxIndex].value = checked;
    }

    onChange(newValue);
  };

  return (
    <div className={css.root} style={style} tabIndex={tabIndex}>
      <Label text={label} required={required} variant="bodyBold" />
      <div className={css.checkboxes}>
        {property.options!.map(({ id, label: checkboxLabel }) => (
          <Checkbox
            key={id}
            checked={Boolean(value.find((checkbox) => checkbox.id === id)?.value)}
            onChange={(checked) => handleChange(id, checked)}
            label={checkboxLabel}
            disabled={disabled}
          />
        ))}
      </div>
      {error && (
        <Typography withMargin variant="labelRegular" className={css.error}>
          {error}
        </Typography>
      )}
    </div>
  );
};
